import { toast } from "react-toastify";
import { _AircraftCargo, _single } from "../../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../../core/services/dataBean/useDataBean"
import { BasicPage } from "../../../theme/Component/BasicPage"
import { BasicTable } from "../../../theme/Component/BasicTable";
import useModal, { MODAL_md, MODAL_SM } from "../../../theme/Component/hooks/useModal";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import usePaginator from "../../../theme/Component/usePaginator";
import { useEffect } from "react";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";

export const Aircraft = () => {

    const _aircraftCargo = useDataBean(_AircraftCargo);
    const { bean, setBean, lista, setLista, handleChange, addRequiredFields, validateForm, isRequired } = _aircraftCargo;
    const modal = useModal("Aeronaves", MODAL_md);
    const modalDelete = useModal("Eliminar Aeronave", MODAL_SM);
    const paginador = usePaginator();

    useEffect(() => {
        getLista();
        addRequiredFields(['AircraftCode', 'Name', 'MaxPayloadKg', 'MaxVolume']);
    }, [])


    const head = [
        { title: 'ID', property: 'IDAircraftCargo', visible: true },
        { title: 'Código', property: 'AircraftCode', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Max Peso Kg', property: 'MaxPayloadKg', visible: true },
        { title: 'Max Volume', property: 'MaxVolume', visible: true },
        { title: 'Actualizada', property: 'LastUpdate', visible: true }
    ]
    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: () => { modal.open(); initParams(); } }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open() } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalDelete.open() } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const getLista = () => {
        _aircraftCargo.getLista({ State: 1 }, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp);
                }
            }
        )
    }
    const initParams = () => {
        setBean({
            State: 1,
            LastUpdate: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID(),
            JSONProps: JSON.stringify({}),
            MaxPayloadKg: 0,
            MaxVolume: 0,
            Name: "",
            Code: ""
        })
    }

    const update = () => {

        if (!validateForm()) {
            toast.error("Por favor complete los campos requeridos");
            return;
        }
        _aircraftCargo.update().then(
            (resp: any) => {
                getLista();
                modal.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }
    const deleteItem = () => {
        _aircraftCargo.deleteItemVoid(bean.IDAircraftCargo).then(
            (resp: any) => {
                getLista();
                modalDelete.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    return (
        <BasicPage titulo="Aeronaves">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable
                        body={lista}
                        head={head}
                        rowSet={setBean}
                        listButtons={listaBotones()}
                        iconButtons={iconButtonsItem}
                    ></BasicTable>
                </div>
                <div className="col-md-12">
                    <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={update}>
                        <div className="row">
                            <div className="col-md-6">
                                <label>Código {isRequired('AircraftCode') ? <span className="text-danger">*</span> : ''}</label>
                                <input className="form-control" type="text" name="AircraftCode" id="AircraftCode" value={bean.AircraftCode} onChange={handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre {isRequired('Name') ? <span className="text-danger">*</span> : ''}</label>
                                <input className="form-control" type="text" name="Name" id="Name" value={bean.Name} onChange={handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Maximo Carga KG {isRequired('MaxPayloadKg') ? <span className="text-danger">*</span> : ''}</label>
                                <input className="form-control" type="number" name="MaxPayloadKg" id="MaxPayloadKg" value={bean.MaxPayloadKg} onChange={handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Maximo Volumen {isRequired('MaxVolume') ? <span className="text-danger">*</span> : ''}</label>
                                <input className="form-control" type="number" name="MaxVolume" id="MaxVolume" value={bean.MaxVolume} onChange={handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalDelete.modal} updateModal={modalDelete.setModal} eventModal={deleteItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>¿Esta seguro de eliminar la aeronave?</label>
                            </div>
                        </div>
                    </ModalConfirm>
                </div>
            </div>
        </BasicPage>
    )
}